import { Injectable } from '@angular/core';
import { Observable,Subject } from 'rxjs';


@Injectable({
    providedIn: 'root',
})
export class BroadCastService {
   // farm subjects
    farmCreatedSubject = new Subject<any>();
    farmUpdatedSubject = new Subject<any>();
    farmPreSelectSubject = new Subject<any>();
    farmHerdChangeSubject = new Subject<any>();
    farmRemovedUserSubject = new Subject<any>();

    //navigation subjects
    enableSingleFarmLinksSubject = new Subject<any>();
    updateNavigationSubject = new Subject<any>();

    toggleNaviationSubject = new Subject<any>();

    //application state (pages) subjects
    stateChangeSubject = new Subject<any>();
    exportingSubject = new Subject<any>();

    //control subjects
    clearControlSubject = new Subject<any>();

    constructor() { }
    

    // farm subject methods 
    sendFarmCreatedMsg(farm:any){
        this.farmCreatedSubject.next(farm);
    }
    onFarmCreated(): Observable<any> {
        return this.farmCreatedSubject.asObservable();
    }

    sendFarmUpdatedMsg(msg:any){
        this.farmUpdatedSubject.next(msg);
    }
    onFarmUpdated(): Observable<any> {
        return this.farmUpdatedSubject.asObservable();
    }
    sendFarmRemovedUserMsg(msgData:any){
        this.farmRemovedUserSubject.next(msgData);
    }
    onFarmRemovedUser(): Observable<any> {
        return this.farmRemovedUserSubject.asObservable();
    }

    sendFarmPreSelectMsg(msgData:any){
        this.farmPreSelectSubject.next(msgData);
    }
    onFarmPreSelect(): Observable<any> {
        return this.farmPreSelectSubject.asObservable();
    }

    sendHerdChangeMsg(msgData:any){
        this.farmHerdChangeSubject.next(msgData);
    }
    onFarmHerdChange(): Observable<any> {
        return this.farmHerdChangeSubject.asObservable();
    }

    // navigation subject methods
    sendEnableSingleFarmLinksMsg(msgData:any){
        this.enableSingleFarmLinksSubject.next(msgData);
    }
    onEnableSingleFarmLinks(): Observable<any> {
        return this.enableSingleFarmLinksSubject.asObservable();
    }

    updateNavigationMsg(msgData:any){
        this.updateNavigationSubject.next(msgData);
    }
    onUpdateNavigation(): Observable<any> {
        return this.updateNavigationSubject.asObservable();
    }

    toggleNavigationMsg(msgData:any){
        this.toggleNaviationSubject.next(msgData);
    }
    onToggleNavigation(): Observable<any> {
        return this.toggleNaviationSubject.asObservable();
    }
  
    //application state (pages) subjects
    stateChangeMsg(msgData:any){
        this.stateChangeSubject.next(msgData);
    }
    onStateChange(): Observable<any> {
        return this.stateChangeSubject.asObservable();
    }

    exportingMsg(msgData:any){
        this.exportingSubject.next(msgData);
    }
    onExporting(): Observable<any> {
        return this.exportingSubject.asObservable();
    }

    // control subject methods
    clearControlMsg(msgData:any){
        this.clearControlSubject.next(msgData);
    }
    onClearControl(): Observable<any> {
        return this.clearControlSubject.asObservable();
    }
	
   
}   